// chart mixin for shared information

export default {
	props: {
		chartData: {
			type: Object,
			required: true
		},
		showTooltip: {
			type: Boolean,
			default: () => true
		},
		prependTooltip: {
			type: String,
			default: () => null
		}
	},
	data() {
		return {};
	},
	methods: {},
	computed: {}
};
// eslint-disable-line
